const onReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
        return;
    }

    callback();
};

const initFooterScrollTop = () => {
    const scrollTopButton = document.querySelector('[data-scroll-top]');

    if (!scrollTopButton) {
        return;
    }

    const updateVisibility = () => {
        if (window.scrollY > 50) {
            scrollTopButton.style.display = 'block';
            return;
        }

        scrollTopButton.style.display = 'none';
    };

    window.addEventListener('scroll', updateVisibility);

    scrollTopButton.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    updateVisibility();
};

export default () => onReady(initFooterScrollTop);
